var Backbone = require('backbone');
var _ = require('lodash');
var template = require('../templates/header.ejs');

'use strict';
module.exports = Backbone.View.extend({
    className: 'header',
    events: {
        'click .clear-search': 'resetSearch',
        'input .search': 'search'   
    },
    /**
   *
   */
    initialize: function(options) {
        _.bindAll(this, 'render');

        this.cms = options.cms;
        this.collection = options.voteOption;
        this.dataLength = this.collection.models.length;
        this.cloned_collection = _.clone(this.collection);
        this.windowStat = this.cms.get('settings')['window_status'];
        this.search = _.debounce(this.search, 300);
    },

    /**
   *
   */
    render: function() {
        this.createModel();
        console.log('Window status: ', this.windowStat);

        this.$el.html(template(this.model));
    
        this.$searchText = this.$('.search-text');
        this.$closeButton = this.$('.clear-search');
        this.$searchInput = this.$('.search');

        return this;
    },
    /**
   *
   */
    createModel: function() {
        var numContestants = this.collection.models.length;
        var params = {
            'copy': this.cms.get('text')['views_nominee_grid'],
            'design': this.cms.get('text')['design'],
            // 'image': this.cms.get('text')['views_page_header']['category_image'],
            'search': this.cms.get('text')['views_nominee_grid'].search.enabled,
            'length': numContestants,
            'windowStat': this.windowStat
        };

        var headlineLength = this.model.headline_copy.length;
        var paragraphLength = this.model.description_copy.length;

        if(headlineLength > 31 || paragraphLength > 74) {
            this.model.headline_copy = this.model.headline_copy.slice(0,31);
            this.model.description_copy = this.model.description_copy.slice(0,74);
        }

        _.extend(this.model, params);
    },
    /**
   *
   */
    search: function(e) {
        var term = e.target.value;
        var collection = this.cloned_collection;

        console.log('Search terms: ', term);

        var pattern = new RegExp(term, 'gi');

        //search for both first and last names store the value in search variable
        var search = collection.models.filter(function(data) {
            return pattern.test(data.get('firstname') + ' ' + data.get('lastname')) || pattern.test(data.get('secondaryinfo'));
        });

        //reset collection based on search results
        if (search.length > 0) {
            this.collection.reset(search);
        } else if (search == '') {
            this.collection.reset();
        }

    },

    /**
   *
   */
    resetSearch: function(e) {
        console.log('e', e, this.cloned_collection);
        // restore the cloned collection
        this.collection.reset(this.cloned_collection.models);
        this.$searchInput.val('');
    },
    /**
   *
   */
    contestantCount: function() {
        var total = this.collection.models.length;
        return total;
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/views/header.js
// module id = 218
// module chunks = 0